import { render, staticRenderFns } from "./SerumIngredientsTab.vue?vue&type=template&id=17928f69&scoped=true&"
import script from "./SerumIngredientsTab.vue?vue&type=script&lang=js&"
export * from "./SerumIngredientsTab.vue?vue&type=script&lang=js&"
import style0 from "./SerumIngredientsTab.vue?vue&type=style&index=0&id=17928f69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17928f69",
  null
  
)

export default component.exports